const { MenuHandler } = require("../handlers/Dashboard/MenuHandler");
const {
  CartDetailHandler,
} = require("../handlers/Dashboard/CartDetailHandler");

const dashboardMapping = {
  Menubar: MenuHandler,
  CartDetail: CartDetailHandler,
};

module.exports = { dashboardMapping };
